import { FontAwesome5 } from '@expo/vector-icons';
import {
  oeChartColors,
  styled,
  useDimension,
} from '@openeducation/oe-rn-themes';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { OEButton } from '../../atoms/oe-button/oe-button';
import { OEText } from '../../atoms/oe-text/oe-text';
import { flex, mb, mt } from '../../style-utils';

export interface ReferralBannerProps {
  onReferralPress: () => void;
  messageType?: 'long' | 'short';
}
export function ReferralBanner({
  onReferralPress,
  messageType = 'long',
}: ReferralBannerProps) {
  const { t } = useTranslation();

  const { isMobile } = useDimension();

  return (
    <Container isMobile={isMobile}>
      <View style={[flex('flex-row'), mb(isMobile ? 8 : 0)]}>
        <Icon style={mt(2)} />
        <OEText
          style={isMobile ? flex('flex-1') : {}}
          fontSize={16}
          color={oeChartColors.pacificDark}
        >
          <Trans
            i18nKey={`home.referralProgram.${
              messageType === 'short' ? 'message' : 'longMessage'
            }`}
            components={{
              b: <OEText color={oeChartColors.pacificDark} fontType="bold" />,
            }}
          />
        </OEText>
      </View>
      <OEButton size="small" type="accent" onPress={onReferralPress}>
        {t('home.referralProgram.action')}
      </OEButton>
    </Container>
  );
}

interface IsMobileProps {
  isMobile: boolean;
}

const Container = styled.View<IsMobileProps>`
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  background-color: ${oeChartColors.aquaBlue};
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  overflow: hidden;
`;

const Icon = styled(FontAwesome5).attrs({
  color: oeChartColors.pacificDark,
  name: 'comment-dollar',
})`
  font-size: 20px;
  margin-right: 11px;
  margin-left: 2px;
`;
